import React from 'react' 
import { Button, Dialog,DialogActions, DialogContent, DialogTitle, SearchBar, Typography } from '../ui/core';
import List from '../users/list';
export default function QuickSearch({title,items,onClick,onClose}) {
    const [searchTerm, setSearchTerm] = React.useState('');
    return (
        <Dialog onClose={onClose} fullScreen>
            <DialogTitle><Typography component="h2">{title || 'Zoeken medewerkers'}</Typography></DialogTitle>
            <DialogContent>
                <SearchBar value={searchTerm} onClose={()=>{setSearchTerm('')}} onKeyUp={setSearchTerm}></SearchBar>
             
                <List items={searchTerm?items.filter(i=>{return JSON.stringify(i).indexOf(searchTerm)>=0}):items} onClick={onClick}/>
            </DialogContent>
            <DialogActions>
                 <Button onClick={onClose} style={{backgroundColor:'#ff6A13'}}>SLUITEN</Button>
            </DialogActions>
        </Dialog>
    )
}
